<template>
  <div id="about">
    <div class="content">
      <div class="top" id="tops">
        <img src='~@/common/img/a_bg.jpg'>
      </div>
      <div class="tab">
        <div :class="searchBarFixed == true ? 'isFixed' :''">
          <ul id="scro">
            <li v-for="(item,index) in aboutChildren" :key="index.path" :class="{active:isShouldActive(item.path)}" @click="$router.push({name:item.name})">
              {{item.name}}
            </li>
          </ul>
        </div>
        <div class="router-view-wrapper">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aboutChildren from '@/router/module/router-children-for-about';
export default {
  data() {
    return {
      aboutChildren,
      searchBarFixed: false,
      scroll: '',
    };
  },
  //离开页面移除监听事件
  destroyed() {
    window.removeEventListener('scroll', this.menuAbout);
  },
  mounted() {
    //滚动监听事件
    window.addEventListener('scroll', this.menuAbout);
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    isShouldActive(path) {
      return this.currentPath.includes(path);
    },
    menuAbout() {
      var _self = this;
      _self.scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var menuTop = document.querySelector('#tops').offsetTop;
      //滑动到指定位置菜单吸顶
      if (_self.scroll > menuTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.top {
  width: 100%;
  margin-bottom: 48px;
  img {
    max-height: 400px;
    width: 100%;
  }
}

.tab ul {
  margin: 0 auto;
  // padding: 64px 0;
  width: 781px;
  font-size: 0;
  text-align: center;
}

.tab ul li {
  position: relative;
  display: inline-block;
  color: rgba(0, 0, 0, 0.72);
  vertical-align: middle;
  font-size: 16px;
  cursor: pointer;
}

.tab ul li:not(:first-child) {
  margin-left: 78px;
}

.tab ul li:not(:first-child)::before {
  position: absolute;
  top: 8px;
  left: -62%;
  width: 2px;
  height: 12px;
  background-color: rgba(0, 0, 0, 0.32);
  content: '';
}

.tab ul li:hover {
  color: #d1551c !important;
}

.active {
  color: #d1551c !important;
}

.active::after {
  position: absolute;
  bottom: -11px;
  left: calc(50% - 8px);
  width: 16px;
  height: 2px;
  background-color: #d1551c;
  content: '';
}
.isFixed {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  height: 60px;
}
.isFixed li {
  color: #000000;
}
.isFixed ul li {
  top: 19px;
}
.isFixed ul li:not(:first-child)::before {
  background-color: #fff;
}
.isFixed .active::after {
  position: absolute;
  bottom: -17px;
  left: calc(14% - 8px);
  width: 64px;
  height: 2px;
  background-color: #d1551c;
  content: '';
}
.router-view-wrapper {
  min-height: 300px;
  padding-top: 48px;
}
</style>
